import PasswordGenerator from './components/PasswordGenerator'
import './styles.css'
import './variables.css'

function App() {
  return (
    <>
       <PasswordGenerator/>
    </>
  )
}

export default App
